// The stock-register import is restricted to a single super-admin user (Robin).
// Keep in sync with STOCK_REGISTER_USER_IDS in
// sattis-backend/middleware/stockRegisterAccess.js (the server enforces it too).
export const STOCK_REGISTER_USER_IDS = ["6aa647b116033bff40dc58f4"];

// Id of the logged-in user: the stored `localId`, or — for sessions saved by an
// older build that has none — the id inside the login token.
const idFromToken = (token) => {
  try {
    const u = JSON.parse(atob(String(token).split(".")[1]))?.user;
    return String(u?.id || u?._id || "");
  } catch {
    return "";
  }
};

export const canImportStockRegister = (user, token) =>
  STOCK_REGISTER_USER_IDS.includes(
    String(user?.localId || user?.id || user?._id || idFromToken(token) || ""),
  );
